import { Action, ActionReducer, combineReducers } from '@ngrx/store';

import * as fromProducts from './products.reducer';

export const featureKey = 'oyanProducts';

export interface ProductsState {
  [fromProducts.featureKey]: fromProducts.State;
}

export interface State {
  [featureKey]: ProductsState;
}

export function reducers(state: ProductsState, action: Action): ActionReducer<ProductsState> {
  return combineReducers({
    [fromProducts.featureKey]: fromProducts.reducer
  })(state, action) as unknown as ActionReducer<ProductsState>;
}
